'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _regulatorAutocomplete = require('./regulator-autocomplete.component');

var _regulatorAutocomplete2 = _interopRequireDefault(_regulatorAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.autocomplete.regulator', []).component('regulatorAutocomplete', _regulatorAutocomplete2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/common/autocomplete/regulator/regulator-autocomplete.module.js